import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "agent-editor-header"
}
const _hoisted_2 = { class: "d-flex align-center w-100" }
const _hoisted_3 = { class: "mr-3 agent-icon-picker-anchor" }
const _hoisted_4 = { class: "agent-icon-picker-grid" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { style: {"min-width":"0"} }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "text-subtitle-1 text-truncate" }
const _hoisted_9 = {
  key: 0,
  class: "agent-overlay-layout"
}
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "d-flex align-center w-100 agent-editor-header" }
const _hoisted_12 = { class: "mr-3 agent-icon-picker-anchor" }
const _hoisted_13 = { class: "agent-icon-picker-grid" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { style: {"min-width":"0"} }
const _hoisted_16 = { class: "d-flex align-center" }
const _hoisted_17 = { class: "text-subtitle-1 text-truncate" }
const _hoisted_18 = { class: "text-caption text-medium-emphasis" }
const _hoisted_19 = { class: "d-flex align-center" }
const _hoisted_20 = { class: "collapsed-header-actions" }
const _hoisted_21 = {
  key: 0,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModelOptionsChoices = _resolveComponent("ModelOptionsChoices")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_IconToggle = _resolveComponent("IconToggle")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_FunctionSelectionDialog = _resolveComponent("FunctionSelectionDialog")!
  const _component_AgentShareDialog = _resolveComponent("AgentShareDialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isOverlay ? 'div' : 'v-card'), _mergeProps({
      class: [_ctx.isOverlay ? 'agent-editor-surface agent-editor-surface--overlay bg-background' : 'ma-0 pa-2 card bg-background']
    }, _ctx.isOverlay ? {} : { color: 'background', density: 'compact', variant: 'elevated', elevation: 4 }), {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          density: "compact",
          onSubmit: _cache[49] || (_cache[49] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            (_ctx.isOverlay && _ctx.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_menu, {
                      modelValue: _ctx.showIconPicker,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showIconPicker) = $event)),
                      "close-on-content-click": false,
                      location: "bottom start",
                      offset: "10"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_avatar, {
                            size: "36",
                            rounded: "lg",
                            class: "agent-icon-tile"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: _ctx.displayIcon,
                                size: "small"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            color: "primary",
                            icon: "mdi-pencil-outline",
                            size: "x-small",
                            variant: "flat",
                            class: "agent-icon-picker-trigger",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                          }), null, 16)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "agent-icon-picker-menu",
                          color: "background",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconPresets, (preset) => {
                                return (_openBlock(), _createBlock(_component_v_btn, {
                                  key: preset,
                                  color: _ctx.iconSelectionValue === preset ? 'primary' : 'default',
                                  variant: _ctx.iconSelectionValue === preset ? 'tonal' : 'text',
                                  icon: "",
                                  size: "small",
                                  class: "agent-icon-option",
                                  onClick: _withModifiers(($event: any) => (_ctx.selectIconPreset(preset)), ["stop","prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      icon: preset,
                                      size: "small"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["color", "variant", "onClick"]))
                              }), 128))
                            ]),
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "agent-icon-picker-divider" }, null, -1)),
                            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "agent-icon-picker-label" }, "Custom MDI Name", -1)),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.iconInput,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.iconInput) = $event)),
                              density: "compact",
                              variant: "outlined",
                              "hide-details": "",
                              class: "mt-2",
                              clearable: "",
                              onBlur: _ctx.commitIconInput,
                              onKeydown: _withKeys(_withModifiers(_ctx.commitIconInput, ["prevent"]), ["enter"])
                            }, {
                              "prepend-inner": _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: _ctx.displayIcon,
                                  color: "primary"
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onBlur", "onKeydown"]),
                            _createElementVNode("a", {
                              class: "agent-icon-picker-link",
                              href: _ctx.mdiBrowseUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _cache[58] || (_cache[58] = _createTextVNode(" Browse all MDI icons ")),
                              _createVNode(_component_v_icon, {
                                icon: "mdi-arrow-right",
                                size: "x-small",
                                class: "ml-1"
                              })
                            ], 8, _hoisted_5)
                          ]),
                          _: 1,
                          __: [59,60]
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.name || 'New Agent'), 1),
                        (_ctx.isPublished)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              color: "success",
                              size: "x-small",
                              class: "ml-2"
                            }, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createTextVNode("Live")
                              ])),
                              _: 1,
                              __: [61]
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isShared && _ctx.sharedAgent)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 1,
                  type: "info",
                  variant: "tonal",
                  class: "ma-3 shared-agent-banner"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Shared by @" + _toDisplayString(_ctx.sharedAgent.ownerUsername) + " — name and model are owner-controlled. ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_expand_transition, null, {
              default: _withCtx(() => [
                (_ctx.isOverlay && _ctx.show)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_v_row, { class: "ma-0 px-4 pb-3 align-stretch flex-nowrap agent-overlay-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "5",
                            class: "pa-0 pr-4 agent-overlay-settings"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                density: "compact",
                                class: "ma-0 pa-0 bg-background"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "The agent name should be a one to 2 word description. Like 'Planner' or 'Coder'."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [62]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.name,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trackFieldUpdate('agent_name'))),
                                        class: "mt-2",
                                        label: "Agent Name",
                                        readonly: _ctx.isShared,
                                        rules: _ctx.isShared ? [] : [() => !!_ctx.name || 'Agent name is required'],
                                        density: "compact",
                                        variant: "outlined"
                                      }, null, 8, ["modelValue", "readonly", "rules"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "The agent description should be a short sentance on what the agent does. Use the agent's name in the\n                    description if you can. Do not use 'You'. This description is used by the mission leader in completing the\n                    mission and is also used if you choose to autofill a squad's workflow."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [63]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.description,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.description) = $event)),
                                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trackFieldUpdate('agent_description'))),
                                        class: "mt-2",
                                        label: "Agent Description",
                                        rules: [() => !!_ctx.description || 'Agent description is required'],
                                        density: "compact",
                                        variant: "outlined"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "Choose a model that you have saved under the Models tab."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [64]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (!_ctx.isShared)
                                        ? (_openBlock(), _createBlock(_component_v_select, {
                                            key: 1,
                                            modelValue: _ctx.model,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model) = $event)),
                                            onBlur: _ctx.modelSelected,
                                            items: _ctx.modelChoices,
                                            class: "mt-2",
                                            "item-title": "name",
                                            "item-value": "id",
                                            "return-object": false,
                                            label: "Agent Model",
                                            variant: "outlined",
                                            rules: [() => !!_ctx.model || 'You must choose a model for your agent to use.'],
                                            density: "compact"
                                          }, null, 8, ["modelValue", "onBlur", "items", "rules"]))
                                        : (_openBlock(), _createBlock(_component_v_text_field, {
                                            key: 2,
                                            "model-value": _ctx.sharedOwnerModelName,
                                            class: "mt-2",
                                            label: "Agent Model (owner-controlled)",
                                            readonly: "",
                                            density: "compact",
                                            variant: "outlined"
                                          }, null, 8, ["model-value"]))
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "Choose a saved voice alias to speak this agent's replies. Leave blank to disable TTS."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [65]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_select, {
                                        modelValue: _ctx.voiceSavedName,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.voiceSavedName) = $event)),
                                        items: _ctx.savedVoiceNames,
                                        label: "Agent Voice (optional)",
                                        class: "mt-2",
                                        variant: "outlined",
                                        density: "compact",
                                        clearable: ""
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "Enable the agent to use tools to perform tasks."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [66]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.enableTools,
                                        "onUpdate:modelValue": [
                                          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.enableTools) = $event)),
                                          _ctx.toggleToolsUsage
                                        ],
                                        label: "Use Tools",
                                        "hide-details": "",
                                        density: "compact",
                                        class: "display-inline my-0 py-0"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  (_ctx.enableTools)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 0,
                                        density: "compact",
                                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.showGlobalTooltips)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                position: "top",
                                                "max-width": "300",
                                                text: "List of tools that the agent can use"
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                                    size: "x-small",
                                                    class: "global-tooltip-icon mt-5 ml-n6"
                                                  }), {
                                                    default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                      _createTextVNode("mdi-information-outline")
                                                    ])),
                                                    _: 2,
                                                    __: [67]
                                                  }, 1040)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_select, {
                                            modelValue: _ctx.selectedTools,
                                            "onUpdate:modelValue": [
                                              _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedTools) = $event)),
                                              _ctx.onToolSelectionChange
                                            ],
                                            items: _ctx.toolsNameList,
                                            label: "Tools",
                                            multiple: "",
                                            chips: "",
                                            density: "compact",
                                            variant: "outlined",
                                            class: "mt-2 mb-n1"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.enableTools && _ctx.selectedTools.length > 0)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 1,
                                        density: "compact",
                                        class: "py-0 my-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "plain",
                                            onClick: _ctx.openFunctionSelectionDialog,
                                            size: "small",
                                            class: "ml-n2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Select Functions (" + _toDisplayString(_ctx.selectedFunctionsCount) + " selected) ", 1)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_list_item, {
                                    density: "compact",
                                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.showGlobalTooltips)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            position: "top",
                                            "max-width": "300",
                                            text: "Enable the agent to look up information in data you've uploaded via the Embeddings tab."
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps(props, {
                                                size: "x-small",
                                                class: "global-tooltip-icon mt-5 ml-n6"
                                              }), {
                                                default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                  _createTextVNode("mdi-information-outline")
                                                ])),
                                                _: 2,
                                                __: [68]
                                              }, 1040)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.enableEmbeddings,
                                        "onUpdate:modelValue": [
                                          _cache[13] || (_cache[13] = ($event: any) => ((_ctx.enableEmbeddings) = $event)),
                                          _ctx.toggleEmbeddingsUsage
                                        ],
                                        label: "Use Embeddings (RAG)",
                                        "hide-details": "",
                                        density: "compact",
                                        class: "display-inline my-0 py-0"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 1
                                  }, 8, ["class"]),
                                  (_ctx.enableEmbeddings)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 2,
                                        density: "compact",
                                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.showGlobalTooltips)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                position: "top",
                                                "max-width": "300",
                                                text: "Datasets to include in the RAG (Retrieval-Augmented Generation) process. These are the datasets you've uploaded via the Embeddings tab."
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                                    size: "x-small",
                                                    class: "global-tooltip-icon mt-5 ml-n6"
                                                  }), {
                                                    default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                      _createTextVNode("mdi-information-outline")
                                                    ])),
                                                    _: 2,
                                                    __: [69]
                                                  }, 1040)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_select, {
                                            modelValue: _ctx.selectedEmbeddings,
                                            "onUpdate:modelValue": [
                                              _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedEmbeddings) = $event)),
                                              _ctx.onEmbeddingCollectionChange
                                            ],
                                            items: _ctx.embeddingsList,
                                            "item-value": "safeName",
                                            class: "mt-2 mb-n1",
                                            multiple: "",
                                            chips: "",
                                            "item-title": "name",
                                            label: "Embeddings to include (RAG)",
                                            variant: "outlined",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.enableEmbeddings && _ctx.showAdvanced)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 3,
                                        density: "compact",
                                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.showGlobalTooltips)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                position: "top",
                                                "max-width": "300",
                                                text: "The embedding specific model to use when looking up information you've uploaded. Don't change this unless you know what it is."
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                                    size: "x-small",
                                                    class: "global-tooltip-icon mt-5 ml-n6"
                                                  }), {
                                                    default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                      _createTextVNode("mdi-information-outline")
                                                    ])),
                                                    _: 2,
                                                    __: [70]
                                                  }, 1040)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_select, {
                                            modelValue: _ctx.embeddingModel,
                                            "onUpdate:modelValue": [
                                              _cache[15] || (_cache[15] = ($event: any) => ((_ctx.embeddingModel) = $event)),
                                              _ctx.onEmbeddingModelChange
                                            ],
                                            items: _ctx.effectiveEmbeddingModelConfigList,
                                            "item-title": "name",
                                            "item-value": "id",
                                            label: "Embedding Model",
                                            rules: [() => (!!_ctx.embeddingModel && _ctx.enableEmbeddings) || 'Embedding Model is required.'],
                                            density: "compact",
                                            variant: "outlined",
                                            class: "display-block mt-2 mb-n1"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.enableEmbeddings)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 4,
                                        density: "compact",
                                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.showGlobalTooltips)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                position: "top",
                                                "max-width": "300",
                                                text: "This corresponds to the type of embeddings you're including and how you want the model to use them. Meta-prompts specific to these options are in your global config. Open = allow the agent to use it's own knowledge in addition, Closed = only use the embeddings, Code = specific prompting for code use and generation."
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                                    size: "x-small",
                                                    class: "global-tooltip-icon mt-5 ml-n6"
                                                  }), {
                                                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                      _createTextVNode("mdi-information-outline")
                                                    ])),
                                                    _: 2,
                                                    __: [71]
                                                  }, 1040)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createVNode(_component_v_select, {
                                            modelValue: _ctx.embeddingType,
                                            "onUpdate:modelValue": [
                                              _cache[16] || (_cache[16] = ($event: any) => ((_ctx.embeddingType) = $event)),
                                              _ctx.onEmbeddingTypeChange
                                            ],
                                            items: _ctx.embeddingTypes,
                                            class: "mt-2",
                                            "item-title": "name",
                                            label: "Embedding type",
                                            variant: "outlined",
                                            density: "compact"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isShared && _ctx.canPublishAgents)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 5,
                                        density: "compact",
                                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.showGlobalTooltips)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                position: "top",
                                                "max-width": "300",
                                                text: "Make this agent publicly accessible via a unique URL"
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                                    size: "x-small",
                                                    class: "global-tooltip-icon mt-5 ml-n6"
                                                  }), {
                                                    default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                      _createTextVNode(" mdi-information-outline ")
                                                    ])),
                                                    _: 2,
                                                    __: [72]
                                                  }, 1040)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.isPublished,
                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isPublished) = $event)),
                                              onChange: _ctx.togglePublish,
                                              label: "Publish Agent",
                                              "hide-details": "",
                                              density: "compact",
                                              class: "display-inline my-0 py-0"
                                            }, null, 8, ["modelValue", "onChange"]),
                                            (_ctx.show)
                                              ? (_openBlock(), _createBlock(_component_Button, {
                                                  key: 0,
                                                  color: "primary",
                                                  buttonClass: "ml-2",
                                                  click: _ctx.showShareDialog,
                                                  icon: "mdi-share-variant",
                                                  size: "medium",
                                                  tooltip: "Share Agent"
                                                }, null, 8, ["click"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.isPublished)
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 1,
                                                  text: "Open Public Page",
                                                  location: "top"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_btn, _mergeProps(props, {
                                                      color: "secondary",
                                                      icon: "mdi-open-in-new",
                                                      size: "small",
                                                      class: "ml-1 d-inline-flex agent-link",
                                                      href: _ctx.publicUrl,
                                                      onClick: _ctx.openPublicUrl,
                                                      variant: "plain",
                                                      target: "_blank"
                                                    }), null, 16, ["href", "onClick"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_ctx.isPublished && _ctx.publishedSlug)
                                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                  key: 2,
                                                  text: "Chat with Agent",
                                                  location: "top"
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_btn, _mergeProps(props, {
                                                      color: "primary",
                                                      icon: "mdi-chat-outline",
                                                      size: "small",
                                                      class: "ml-0 d-inline-flex agent-link",
                                                      variant: "plain",
                                                      onClick: _ctx.goToChat
                                                    }), null, 16, ["onClick"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["class"]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.isShared && _ctx.isPublished && _ctx.publicUrl)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 6,
                                        density: "compact",
                                        class: "ma-0 pa-0 mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            "model-value": _ctx.publicUrl,
                                            label: "Public URL",
                                            readonly: "",
                                            density: "compact",
                                            variant: "outlined",
                                            class: "mt-2",
                                            "append-inner-icon": "mdi-content-copy",
                                            "onClick:appendInner": _ctx.copyPublicUrl
                                          }, null, 8, ["model-value", "onClick:appendInner"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.showAdvanced)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 7,
                                        density: "compact",
                                        class: "ma-0 pa-0 mt-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ModelOptionsChoices, {
                                            onUpdate: _ctx.updateOptions,
                                            modelOptionsInput: _ctx.modelOptions,
                                            modelName: _ctx.modelConfig?.model || ''
                                          }, null, 8, ["onUpdate", "modelOptionsInput", "modelName"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "7",
                            class: "pa-0 pl-4 d-flex flex-column agent-overlay-prompt-column"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.systemPrompt,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.systemPrompt) = $event)),
                                onBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.trackFieldUpdate('agent_prompt'))),
                                loading: _ctx.loading,
                                disabled: _ctx.loading,
                                class: "mt-2 hide-scrollbar flex-grow-1 agent-overlay-prompt",
                                label: "Agent Prompt",
                                variant: "outlined",
                                rules: [() => !!_ctx.systemPrompt || 'Agent prompt is required'],
                                density: "compact",
                                rows: "1",
                                "no-resize": "",
                                "hide-details": ""
                              }, {
                                "append-inner": _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    (_ctx.name != '' && _ctx.description != '' && _ctx.model != null)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          text: "Autofill"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _mergeProps({ class: "autocomplete-icon" }, props, {
                                              color: "primary",
                                              icon: "mdi-lightning-bolt-outline",
                                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.autofillPrompt()))
                                            }), null, 16)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "loading", "disabled", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _withDirectives((_openBlock(), _createBlock(_component_v_list, {
                      key: 1,
                      density: "compact",
                      class: "ma-0 pa-0 card-content bg-background"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isOverlay)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              density: "compact",
                              class: "ma-0 pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showIconPicker,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showIconPicker) = $event)),
                                    "close-on-content-click": false,
                                    location: "bottom start",
                                    offset: "10"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_v_avatar, {
                                          size: "36",
                                          rounded: "lg",
                                          class: "agent-icon-tile"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: _ctx.displayIcon,
                                              size: "small"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_btn, _mergeProps(props, {
                                          color: "primary",
                                          icon: "mdi-pencil-outline",
                                          size: "x-small",
                                          variant: "flat",
                                          class: "agent-icon-picker-trigger",
                                          onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                                        }), null, 16)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        class: "agent-icon-picker-menu",
                                        color: "background",
                                        onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconPresets, (preset) => {
                                              return (_openBlock(), _createBlock(_component_v_btn, {
                                                key: preset,
                                                color: _ctx.iconSelectionValue === preset ? 'primary' : 'default',
                                                variant: _ctx.iconSelectionValue === preset ? 'tonal' : 'text',
                                                icon: "",
                                                size: "small",
                                                class: "agent-icon-option",
                                                onClick: _withModifiers(($event: any) => (_ctx.selectIconPreset(preset)), ["stop","prevent"])
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    icon: preset,
                                                    size: "small"
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["color", "variant", "onClick"]))
                                            }), 128))
                                          ]),
                                          _cache[74] || (_cache[74] = _createElementVNode("div", { class: "agent-icon-picker-divider" }, null, -1)),
                                          _cache[75] || (_cache[75] = _createElementVNode("div", { class: "agent-icon-picker-label" }, "Custom MDI Name", -1)),
                                          _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.iconInput,
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.iconInput) = $event)),
                                            density: "compact",
                                            variant: "outlined",
                                            "hide-details": "",
                                            class: "mt-2",
                                            clearable: "",
                                            onBlur: _ctx.commitIconInput,
                                            onKeydown: _withKeys(_withModifiers(_ctx.commitIconInput, ["prevent"]), ["enter"])
                                          }, {
                                            "prepend-inner": _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: _ctx.displayIcon,
                                                color: "primary"
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "onBlur", "onKeydown"]),
                                          _createElementVNode("a", {
                                            class: "agent-icon-picker-link",
                                            href: _ctx.mdiBrowseUrl,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                                          }, [
                                            _cache[73] || (_cache[73] = _createTextVNode(" Browse all MDI icons ")),
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-arrow-right",
                                              size: "x-small",
                                              class: "ml-1"
                                            })
                                          ], 8, _hoisted_14)
                                        ]),
                                        _: 1,
                                        __: [74,75]
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.name || 'New Agent'), 1),
                                      (_ctx.isPublished)
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            color: "success",
                                            size: "x-small",
                                            class: "ml-2"
                                          }, {
                                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                                              _createTextVNode("Live")
                                            ])),
                                            _: 1,
                                            __: [76]
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.icon || _ctx.defaultAgentIcon), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "The agent name should be a one to 2 word description. Like 'Planner' or 'Coder'."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[77] || (_cache[77] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [77]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.name,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.name) = $event)),
                              onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.trackFieldUpdate('agent_name'))),
                              label: "Agent Name",
                              class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                              readonly: _ctx.isShared,
                              rules: _ctx.isShared ? [] : [() => !!_ctx.name || 'Agent name is required'],
                              density: "compact",
                              variant: "outlined"
                            }, null, 8, ["modelValue", "class", "readonly", "rules"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "The agent description should be a short sentance on what the agent does. Use the agent's name in the\n              description if you can. Do not use 'You'. This description is used by the mission leader in completing the\n              mission and is also used if you choose to autofill a squad's workflow."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[78] || (_cache[78] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [78]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.description,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.description) = $event)),
                              onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.trackFieldUpdate('agent_description'))),
                              label: "Agent Description",
                              class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                              rules: [() => !!_ctx.description || 'Agent description is required'],
                              density: "compact",
                              variant: "outlined"
                            }, null, 8, ["modelValue", "class", "rules"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass([_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1 h-100' : 'ma-0 pa-0 mt-1', { 'agent-prompt-item': _ctx.isOverlay }])
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "The agent prompt should be a longer set of instructions on exactly what the agent's job is. Include what\n              it should do and what it shouldn't do. You can attempt to autofill this field, but results will vary."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[79] || (_cache[79] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [79]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isPromptExpanded)
                              ? (_openBlock(), _createBlock(_component_v_textarea, {
                                  key: 1,
                                  modelValue: _ctx.systemPrompt,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.systemPrompt) = $event)),
                                  onBlur: _cache[32] || (_cache[32] = ($event: any) => (_ctx.trackFieldUpdate('agent_prompt'))),
                                  loading: _ctx.loading,
                                  disabled: _ctx.loading,
                                  class: _normalizeClass([_ctx.isOverlay ? 'mt-2 h-100' : 'pt-2', 'hide-scrollbar']),
                                  label: "Agent Prompt",
                                  variant: "outlined",
                                  rules: [() => !!_ctx.systemPrompt || 'Agent prompt is required'],
                                  density: "compact",
                                  rows: _ctx.isOverlay ? 1 : 5,
                                  "no-resize": "",
                                  "hide-details": ""
                                }, {
                                  "append-inner": _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      (!_ctx.isOverlay)
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 0,
                                            icon: "mdi-arrow-expand",
                                            color: "primary",
                                            onClick: _ctx.togglePromptExpansion,
                                            class: "expand-prompt-icon",
                                            style: {"cursor":"pointer"}
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.name != '' && _ctx.description != '' && _ctx.model != null)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 1,
                                            text: "Autofill"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps({ class: "autocomplete-icon" }, props, {
                                                color: "primary",
                                                icon: "mdi-lightning-bolt-outline",
                                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.autofillPrompt()))
                                              }), null, 16)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "loading", "disabled", "class", "rules", "rows"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "Choose a model that you have saved under the Models tab."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[80] || (_cache[80] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [80]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isShared)
                              ? (_openBlock(), _createBlock(_component_v_select, {
                                  key: 1,
                                  modelValue: _ctx.model,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.model) = $event)),
                                  onBlur: _ctx.modelSelected,
                                  items: _ctx.modelChoices,
                                  class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                                  "item-title": "name",
                                  "item-value": "id",
                                  "return-object": false,
                                  label: "Agent Model",
                                  variant: "outlined",
                                  rules: [() => !!_ctx.model || 'You must choose a model for your agent to use.'],
                                  density: "compact"
                                }, null, 8, ["modelValue", "onBlur", "items", "class", "rules"]))
                              : (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 2,
                                  "model-value": _ctx.sharedOwnerModelName,
                                  class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                                  label: "Agent Model (owner-controlled)",
                                  readonly: "",
                                  density: "compact",
                                  variant: "outlined"
                                }, null, 8, ["model-value", "class"]))
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mt-1' : 'ma-0 pa-0 mt-1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "Choose a saved voice alias to speak this agent's replies. Leave blank to disable TTS."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[81] || (_cache[81] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [81]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.voiceSavedName,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.voiceSavedName) = $event)),
                              items: _ctx.savedVoiceNames,
                              label: "Agent Voice (optional)",
                              class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                              variant: "outlined",
                              density: "compact",
                              clearable: ""
                            }, null, 8, ["modelValue", "items", "class"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "Enable the agent to use tools to perform tasks."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[82] || (_cache[82] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [82]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.enableTools,
                              "onUpdate:modelValue": [
                                _cache[35] || (_cache[35] = ($event: any) => ((_ctx.enableTools) = $event)),
                                _ctx.toggleToolsUsage
                              ],
                              label: "Use Tools",
                              "hide-details": "",
                              density: "compact",
                              class: "display-inline my-0 py-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.enableTools)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 1,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "List of tools that the agent can use"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                                            _createTextVNode("mdi-information-outline")
                                          ])),
                                          _: 2,
                                          __: [83]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.selectedTools,
                                  "onUpdate:modelValue": [
                                    _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selectedTools) = $event)),
                                    _ctx.onToolSelectionChange
                                  ],
                                  items: _ctx.toolsNameList,
                                  label: "Tools",
                                  multiple: "",
                                  chips: "",
                                  density: "compact",
                                  variant: "outlined",
                                  class: _normalizeClass(_ctx.isOverlay ? 'mt-2 mb-n1' : 'mt-2')
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "class"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enableTools && _ctx.selectedTools.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 2,
                              density: "compact",
                              class: "py-0 my-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  variant: "plain",
                                  onClick: _ctx.openFunctionSelectionDialog,
                                  size: "small",
                                  class: "ml-n2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Select Functions (" + _toDisplayString(_ctx.selectedFunctionsCount) + " selected) ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_list_item, {
                          density: "compact",
                          class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                        }, {
                          default: _withCtx(() => [
                            (_ctx.showGlobalTooltips)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  position: "top",
                                  "max-width": "300",
                                  text: "Enable the agent to look up information in data you've uploaded via the Embeddings tab."
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps(props, {
                                      size: "x-small",
                                      class: "global-tooltip-icon mt-5 ml-n6"
                                    }), {
                                      default: _withCtx(() => _cache[84] || (_cache[84] = [
                                        _createTextVNode("mdi-information-outline")
                                      ])),
                                      _: 2,
                                      __: [84]
                                    }, 1040)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_checkbox, {
                              modelValue: _ctx.enableEmbeddings,
                              "onUpdate:modelValue": [
                                _cache[37] || (_cache[37] = ($event: any) => ((_ctx.enableEmbeddings) = $event)),
                                _ctx.toggleEmbeddingsUsage
                              ],
                              label: "Use Embeddings (RAG)",
                              "hide-details": "",
                              density: "compact",
                              class: "display-inline my-0 py-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        (_ctx.enableEmbeddings)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 3,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "Datasets to include in the RAG (Retrieval-Augmented Generation) process. These are the datasets you've uploaded via the Embeddings tab."
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[85] || (_cache[85] = [
                                            _createTextVNode("mdi-information-outline")
                                          ])),
                                          _: 2,
                                          __: [85]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.selectedEmbeddings,
                                  "onUpdate:modelValue": [
                                    _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selectedEmbeddings) = $event)),
                                    _ctx.onEmbeddingCollectionChange
                                  ],
                                  items: _ctx.embeddingsList,
                                  "item-value": "safeName",
                                  class: _normalizeClass(_ctx.isOverlay ? 'mt-2 mb-n1' : 'pt-2'),
                                  multiple: "",
                                  chips: "",
                                  "item-title": "name",
                                  label: "Embeddings to include (RAG)",
                                  variant: "outlined",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "class"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enableEmbeddings && _ctx.showAdvanced)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 4,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "The embedding specific model to use when looking up information you've uploaded. Don't change this unless you know what it is."
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                                            _createTextVNode("mdi-information-outline")
                                          ])),
                                          _: 2,
                                          __: [86]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.embeddingModel,
                                  "onUpdate:modelValue": [
                                    _cache[39] || (_cache[39] = ($event: any) => ((_ctx.embeddingModel) = $event)),
                                    _ctx.onEmbeddingModelChange
                                  ],
                                  items: _ctx.effectiveEmbeddingModelConfigList,
                                  "item-title": "name",
                                  "item-value": "id",
                                  label: "Embedding Model",
                                  rules: [() => (!!_ctx.embeddingModel && _ctx.enableEmbeddings) || 'Embedding Model is required.'],
                                  density: "compact",
                                  variant: "outlined",
                                  class: _normalizeClass(_ctx.isOverlay ? 'display-block mt-2 mb-n1' : 'display-block pt-2')
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules", "class"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.enableEmbeddings)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 5,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "This corresponds to the type of embeddings you're including and how you want the model to use them. Meta-prompts specific to these options are in your global config. Open = allow the agent to use it's own knowledge in addition, Closed = only use the embeddings, Code = specific prompting for code use and generation."
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[87] || (_cache[87] = [
                                            _createTextVNode("mdi-information-outline")
                                          ])),
                                          _: 2,
                                          __: [87]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_select, {
                                  modelValue: _ctx.embeddingType,
                                  "onUpdate:modelValue": [
                                    _cache[40] || (_cache[40] = ($event: any) => ((_ctx.embeddingType) = $event)),
                                    _ctx.onEmbeddingTypeChange
                                  ],
                                  items: _ctx.embeddingTypes,
                                  class: _normalizeClass(_ctx.isOverlay ? 'mt-2' : 'pt-2'),
                                  "item-title": "name",
                                  label: "Embedding type",
                                  variant: "outlined",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "class"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.showAdvanced)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 6,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "When enabled, the agent's system prompt will be combined with any system prompts passed in from external tools. The agent's prompt comes first."
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[88] || (_cache[88] = [
                                            _createTextVNode(" mdi-information-outline ")
                                          ])),
                                          _: 2,
                                          __: [88]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.combineSystemPrompts,
                                  "onUpdate:modelValue": [
                                    _cache[41] || (_cache[41] = ($event: any) => ((_ctx.combineSystemPrompts) = $event)),
                                    _ctx.toggleCombineSystemPrompts
                                  ],
                                  label: "Combine System Prompts",
                                  "hide-details": "",
                                  class: "display-inline"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.showAdvanced)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 7,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "When enabled, any additional system prompts from external tools will be converted to user messages instead of being treated as system prompts."
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[89] || (_cache[89] = [
                                            _createTextVNode(" mdi-information-outline ")
                                          ])),
                                          _: 2,
                                          __: [89]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.convertSystemPrompt,
                                  "onUpdate:modelValue": [
                                    _cache[42] || (_cache[42] = ($event: any) => ((_ctx.convertSystemPrompt) = $event)),
                                    _ctx.toggleConvertSystemPrompt
                                  ],
                                  label: "Convert System Prompts to User Messages",
                                  "hide-details": "",
                                  class: "display-inline"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (!_ctx.isShared && _ctx.canPublishAgents)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 8,
                              density: "compact",
                              class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0 mb-n1' : 'ma-0 pa-0 mb-n1')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showGlobalTooltips)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      position: "top",
                                      "max-width": "300",
                                      text: "Make this agent publicly accessible via a unique URL"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps(props, {
                                          size: "x-small",
                                          class: "global-tooltip-icon mt-5 ml-n6"
                                        }), {
                                          default: _withCtx(() => _cache[90] || (_cache[90] = [
                                            _createTextVNode(" mdi-information-outline ")
                                          ])),
                                          _: 2,
                                          __: [90]
                                        }, 1040)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.isPublished,
                                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.isPublished) = $event)),
                                    onChange: _ctx.togglePublish,
                                    label: "Publish Agent",
                                    "hide-details": "",
                                    density: "compact",
                                    class: "display-inline my-0 py-0"
                                  }, null, 8, ["modelValue", "onChange"]),
                                  (_ctx.show)
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        color: "primary",
                                        buttonClass: "ml-2",
                                        click: _ctx.showShareDialog,
                                        icon: "mdi-share-variant",
                                        size: "medium",
                                        tooltip: "Share Agent"
                                      }, null, 8, ["click"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isPublished)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 1,
                                        text: "Open Public Page",
                                        location: "top"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn, _mergeProps(props, {
                                            color: "secondary",
                                            icon: "mdi-open-in-new",
                                            size: "small",
                                            class: "ml-1 d-inline-flex agent-link",
                                            href: _ctx.publicUrl,
                                            onClick: _ctx.openPublicUrl,
                                            variant: "plain",
                                            target: "_blank"
                                          }), null, 16, ["href", "onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.isPublished && _ctx.publishedSlug)
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 2,
                                        text: "Chat with Agent",
                                        location: "top"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn, _mergeProps(props, {
                                            color: "primary",
                                            icon: "mdi-chat-outline",
                                            size: "small",
                                            class: "ml-0 d-inline-flex agent-link",
                                            variant: "plain",
                                            onClick: _ctx.goToChat
                                          }), null, 16, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (!_ctx.isShared && _ctx.isPublished && _ctx.publicUrl)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 9,
                              density: "compact",
                              class: _normalizeClass(_ctx.isOverlay ? 'ma-0 pa-0 mt-2' : 'ma-0 pa-0')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  "model-value": _ctx.publicUrl,
                                  label: "Public URL",
                                  readonly: "",
                                  density: "compact",
                                  variant: "outlined",
                                  class: "mt-2",
                                  "append-inner-icon": "mdi-content-copy",
                                  "onClick:appendInner": _ctx.copyPublicUrl
                                }, null, 8, ["model-value", "onClick:appendInner"])
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.showAdvanced)
                          ? (_openBlock(), _createBlock(_component_ModelOptionsChoices, {
                              key: 10,
                              onUpdate: _ctx.updateOptions,
                              modelOptionsInput: _ctx.modelOptions,
                              modelName: _ctx.modelConfig?.model || ''
                            }, null, 8, ["onUpdate", "modelOptionsInput", "modelName"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.show]
                    ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, {
              class: _normalizeClass({ 'agent-editor-actions--overlay': _ctx.isOverlay })
            }, {
              default: _withCtx(() => [
                (_ctx.show)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      color: "primary",
                      class: "mr-4",
                      type: "submit",
                      disabled: _ctx.saveDisabled,
                      click: _ctx.saveAgent,
                      icon: "mdi-check-bold",
                      size: "x-large",
                      tooltip: "Save"
                    }, null, 8, ["disabled", "click"]))
                  : _createCommentVNode("", true),
                (_ctx.show && !_ctx.isShared)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      color: "primary",
                      class: "mr-4",
                      type: "submit",
                      click: _ctx.initiateDeleteAgent,
                      icon: "mdi-trash-can-outline",
                      size: "x-large",
                      tooltip: "Delete"
                    }, null, 8, ["click"]))
                  : _createCommentVNode("", true),
                (!_ctx.show)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_v_avatar, {
                        size: "28",
                        rounded: "lg",
                        class: "mr-3 collapsed-header-avatar agent-icon-tile",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.toggleCardExpansion(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: _ctx.displayIcon,
                            size: "small"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, {
                        text: _ctx.name,
                        location: "top",
                        "open-delay": 400
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("span", _mergeProps(props, {
                            class: "collapsed-header-name",
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.toggleCardExpansion(true)))
                          }), _toDisplayString(_ctx.name), 17)
                        ]),
                        _: 1
                      }, 8, ["text"]),
                      _createVNode(_component_v_spacer, {
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.toggleCardExpansion(true))),
                        class: "collapsed-header-spacer"
                      }),
                      _createElementVNode("div", _hoisted_20, [
                        (_ctx.isPublished)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              color: "success",
                              size: "x-small"
                            }, {
                              default: _withCtx(() => _cache[91] || (_cache[91] = [
                                _createTextVNode("LIVE")
                              ])),
                              _: 1,
                              __: [91]
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isPublished)
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 1,
                              text: "Open Public Page",
                              location: "top"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  color: "secondary",
                                  icon: "mdi-open-in-new",
                                  size: "small",
                                  class: "agent-link",
                                  href: _ctx.publicUrl,
                                  variant: "plain",
                                  target: "_blank"
                                }), null, 16, ["href"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isPublished && _ctx.publishedSlug)
                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 2,
                              text: "Chat with Agent",
                              location: "top"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  color: "primary",
                                  icon: "mdi-chat-outline",
                                  size: "small",
                                  class: "agent-link",
                                  variant: "plain",
                                  onClick: _ctx.goToChat
                                }), null, 16, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          icon: "mdi-chevron-down",
                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.toggleCardExpansion(true)))
                        })
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_IconToggle, {
                        value: _ctx.showAdvanced,
                        onValue: _ctx.toggleAdvanced,
                        highlightColor: "primary"
                      }, null, 8, ["value", "onValue"]),
                      (!_ctx.isOverlay)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "primary",
                            icon: "mdi-chevron-up",
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.toggleCardExpansion(false)))
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        (_ctx.waiting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ConfirmationDialog, {
          modelValue: _ctx.showDeleteConfirmationDialog,
          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showDeleteConfirmationDialog) = $event)),
          title: "Confirm Agent Deletion",
          message: "Are you sure you want to delete this agent configuration?",
          itemName: _ctx.agentNameToDelete,
          itemType: "agent",
          loading: _ctx.waiting,
          onConfirm: _ctx.confirmAgentDelete,
          onCancel: _ctx.cancelDeleteAgent
        }, null, 8, ["modelValue", "itemName", "loading", "onConfirm", "onCancel"]),
        _createVNode(_component_FunctionSelectionDialog, {
          show: _ctx.showFunctionSelectionDialog,
          "selected-tool-names": _ctx.selectedTools,
          "initial-selected-functions": _ctx.toolOptions.selectedFunctions || {},
          "override-server-tools": _ctx.isShared ? _ctx.ownerToolsByServerName : null,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.showFunctionSelectionDialog = $event)),
          onSave: _ctx.handleFunctionSelectionSave
        }, null, 8, ["show", "selected-tool-names", "initial-selected-functions", "override-server-tools", "onSave"]),
        (!_ctx.isShared)
          ? (_openBlock(), _createBlock(_component_AgentShareDialog, {
              key: 1,
              modelValue: _ctx.showShare,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.showShare) = $event)),
              ownerUsername: _ctx.username,
              slug: _ctx.publishedSlug,
              agentName: _ctx.name
            }, null, 8, ["modelValue", "ownerUsername", "slug", "agentName"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.showEmbeddingModelMismatchDialog,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.showEmbeddingModelMismatchDialog) = $event)),
          "max-width": "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-h5" }, {
                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                    _createTextVNode("Embedding Model Mismatch")
                  ])),
                  _: 1,
                  __: [92]
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => _cache[93] || (_cache[93] = [
                    _createTextVNode(" Selected embedding collections must use the same embedding model. Incompatible collections have been removed. ")
                  ])),
                  _: 1,
                  __: [93]
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.showEmbeddingModelMismatchDialog = false))
                    }, {
                      default: _withCtx(() => _cache[94] || (_cache[94] = [
                        _createTextVNode("OK")
                      ])),
                      _: 1,
                      __: [94]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 16, ["class"])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isPromptExpanded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "prompt-overlay",
            onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.togglePromptExpansion && _ctx.togglePromptExpansion(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.isPromptExpanded)
        ? (_openBlock(), _createBlock(_component_v_textarea, {
            key: 1,
            modelValue: _ctx.systemPrompt,
            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.systemPrompt) = $event)),
            onBlur: _cache[57] || (_cache[57] = ($event: any) => (_ctx.trackFieldUpdate('agent_prompt'))),
            loading: _ctx.loading,
            disabled: _ctx.loading,
            class: "hide-scrollbar prompt-expanded",
            label: "Agent Prompt",
            variant: "outlined",
            "hide-details": "",
            density: "compact"
          }, {
            "append-inner": _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-arrow-collapse",
                  color: "primary",
                  onClick: _ctx.togglePromptExpansion,
                  class: "expand-prompt-icon",
                  style: {"cursor":"pointer"}
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "loading", "disabled"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}